import React from "react";
import { Button, Typography } from "antd";
import TourOverlay from "../../Components/Tour/TourOverlay";

interface JobPostHeaderProps {
  handleAddPost: () => void;
}

const JobPostHeader: React.FC<JobPostHeaderProps> = ({ handleAddPost }) => {
  return (
    <div className="job-posts-page-header">
      <Typography.Title level={4} style={{ margin: 0 }} ellipsis>
        Job Posts
      </Typography.Title>
      <TourOverlay targetId="add-post-button">
        <Button type="primary" onClick={handleAddPost} size="middle" className="add-post-button-pulse">
          Add Job Post
        </Button>
      </TourOverlay>
    </div>
  );
};

export default JobPostHeader;
